module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SEwlMj/tc-custom/9781459237445.jpg?1705018941259",
      "alt": "This image is the cover for the book For the Sake of Their Baby"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("For the Sake of Their Baby\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A RISKY REUNION")]), _c('br'), _c('br'), _vm._v("When her doorbell rang, a pregnant Liz Chase’s heart raced at the sight of her handsomeand until now incarceratedhusband, Alex, standing on the porch. For six months Liz had tried to understand why Alex had murdered her uncle, and why he refused to discuss that fateful night. Then she learned that he’d confessed because he thought she was the guilty partyand Liz didn’t know whether to be flattered or furious. But with a killer still on the loose and Alex’s freedom on the line, Liz had to help clear her husband’s nameall for the sake of their baby.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alice Sharpe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("I was born in Sacramento, California where I launched my writing career by “publishing” a family newspaper. Circulation was dismal. After school, I married the love of my life. We spent years juggling children and pets while living on sailboats. All the while, I read like a crazy woman (devoured Agatha Christie) and wrote stories of my own, eventually selling to magazines and then book publishers. Now, 45 novels later, I’m concentrating on romantic suspense where my true interest lies.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0